import React, { useContext, useMemo } from 'react';
import { Accordion, H6 } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';

import FooterContext from '../service/FooterContext';
import MenuLinks from '../shared/MenuLinks';
import themeStyles from '../Footer.styles';
import { stripMarkdownHeading } from '../../../utils/markdown';

const MenuTitle = themeStyles.apply(H6, 'MenuTitle');

const MenuMainDSRAccordion = () => {
  const { navigationItems, mobileMainAccordionIconName, styles, footerFontFamilyBold } = useContext(FooterContext);

  const accordionItems = useMemo(
    () =>
      navigationItems?.items?.map((items, index) => ({
        key: index,
        title: (
          <MenuTitle fontFamily={footerFontFamilyBold}>
            {compiler(stripMarkdownHeading(items?.categoryTitle))}
          </MenuTitle>
        ),
        content: <MenuLinks data={items} showHeader={false} noLastChild />,
      })),
    [],
  );

  return (
    <Accordion
      items={accordionItems}
      isCompact
      pb="8px"
      contentContainerStyles={styles.accordionContentContainer}
      hideBorderOnLastItem={false}
      iconName={mobileMainAccordionIconName}
    />
  );
};

export default MenuMainDSRAccordion;
